import {afterNextRender, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonModule, NgClass} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";

interface ITreeNode {
    label: string;
    icon?: string;
    expanded?: boolean;
    children?: ITreeNode[];
    data?: any;
}

// Sample tree data
const treeData = [
    {
        label: 'Documents',
        expanded: true,
        children: [
            {
                label: 'Projects',
                expanded: false,
                children: [
                    {
                        label: 'Project A',
                        expanded: false,
                        children: [
                            {
                                label: 'Project A',
                                expanded: false,
                            },
                            {
                                label: 'Project B'
                            }
                        ]
                    },
                    {
                        label: 'Project B'
                    }
                ]
            },
            {
                label: 'Reports',
                expanded: false,
                children: [
                    {
                        label: 'Annual Report'
                    }
                ]
            }
        ]
    }
];

@Component({
    selector: 'white-label-tree-view',
    templateUrl: './tree-view.component.html',
    imports: [
        NgClass,
        CommonModule,
        TranslateModule

    ],
    standalone: true,
    providers: [
    ]
})
export class TreeViewComponent {
    @Input() treeData: ITreeNode[] = treeData;
    @Output() nodeClick = new EventEmitter<ITreeNode>();
    @Output() nodeNewClick = new EventEmitter<any>();

    onNodeClick($event: any, node: ITreeNode): void {
        $event.stopPropagation();
        this.nodeClick.emit(node);
    }

    toggle($event: any, node: ITreeNode): void {
        $event.stopPropagation();
        node.expanded = !node.expanded
    }

    newNode($event: any, node: ITreeNode): void {
        $event.stopPropagation();
        this.nodeNewClick.emit(node)
        node.children?.push({
            label: 'Project A',
        })
    }
}

